'use client';

import Image from 'next/image';
import { useState } from 'react';

interface BlogPostImageProps {
  src: string;
  alt: string;
  priority?: boolean;
}

export default function BlogPostImage({ src, alt, priority = false }: BlogPostImageProps) {
  const [imgSrc, setImgSrc] = useState(src);
  const [isError, setIsError] = useState(false);
  
  // Fallback image if the Strapi image URL is invalid
  const fallbackImageUrl = "/images/blog-placeholder.jpg";

  const handleError = () => {
    console.error(`Image failed to load: ${src}`);
    setImgSrc(fallbackImageUrl);
    setIsError(true);
  };

  return (
    <div className="relative aspect-[16/9] w-full mb-10">
      <Image
        src={imgSrc}
        alt={alt}
        fill
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        className={`object-cover ${isError ? 'bg-gradient-to-br from-blue-900/40 to-gray-900' : ''}`}
        priority={priority}
        onError={handleError}
      />
    </div>
  );
} 